<template lang="pug">
  div.e-journal-json-log
    div(
    v-for="value, name in transformedItems"
    :class="getItemClass(value, name)"
    ).item
      span.name {{`${name} `}}
      span(
      v-if="typeof value === 'boolean'"
      ).value {{value ? 'Да' : 'Нет'}}
      span(
      v-else
      v-html="value"
      ).value
    div(
      v-if="hideEnglishAttributes && hasSystemItems"
    ).system
      a(
      href="#"
      @click.stop.prevent="englishAttrOpened = !englishAttrOpened"
      ) {{englishAttrOpened === false ? 'Показать системные поля' : 'Скрыть системные поля'}}
      div(
      v-if="englishAttrOpened"
      v-for="value, name in transformedSystemItems"
      :class="getItemClass(value, name)"
      ).item
        span.name {{`${name} `}}
        span(
        v-if="typeof value === 'boolean'"
        ).value {{value ? 'Да' : 'Нет'}}
        span(
        v-else
        v-html="value"
        ).value
</template>

<script>
  export default {
    name: 'e-journal-json-log',
    props: {
      jsonStringOrObject: String,
      jsonStringOrObjectPrev: String,
      showDiff: {
        type: Boolean,
        default: false
      },
      markNulledAsCreated: {
        type: Boolean,
        default: true
      },
      hideEnglishAttributes: {
        type: Boolean,
        default: true
      }
    },
    data: () => ({
      englishAttrOpened: false
    }),
    computed: {
      hasSystemItems () {
        return Object.keys(this.transformedSystemItems).length > 0
      },
      transformedItems () {
        if (this.hideEnglishAttributes === true) {
          let orig = this.items
          let obj = {}
          for (let attr in orig) {
            if (this.isRus(attr) === true) {
              obj[attr] = orig[attr]
            }
          }
          return obj
        }
        return this.items
      },
      transformedSystemItems () {
        if (this.hideEnglishAttributes === true) {
          let orig = this.items
          let obj = {}
          for (let attr in orig) {
            if (this.isRus(attr) === false) {
              obj[attr] = orig[attr]
            }
          }
          return obj
        }
        return {}
      },
      items () {
        if (this.jsonStringOrObject) {
          return this.getParsedValue(this.jsonStringOrObject)
        }
        return {}
      },
      prevItems () {
        if (this.jsonStringOrObjectPrev) {
          return this.getParsedValue(this.jsonStringOrObjectPrev)
        }
        return {}
      }
    },
    methods: {
      isRus (attr) {
        return /[А-ЯЁ]/i.test(attr.toString())
      },
      getItemClass (value, name) {
        let classes = []
        if (this.prevItems[name] !== value) {
          classes.push('diffed')
        }
        if (this.showDiff === true && !this.prevItems.hasOwnProperty(name)) {
          classes.push(
            this.markNulledAsCreated
              ? 'created'
              : 'removed'
          )
        }
        return classes
      },
      getParsedValue (val) {
        let obj = {}
        try {
          if (val instanceof Object) {
            obj = val
          } else {
            obj = JSON.parse(val)
          }
        } catch (e) {
          console.error(e)
          obj = {
            'Ошибка разбора информации': e.toString()
          }
        }
        return obj
      }
    }
  }
</script>
